import {Device} from "../../types/device";
import {getDeviceColorInfo} from "../../constants/deviceColors";

type Props = {
    device?: Device;
    color: string;
    storage: string;
    onColorChange: (color: string) => void;
    onStorageChange: (storage: string) => void;
};

export default function PhoneConfiguration({device, color, storage, onColorChange, onStorageChange}: Props) {
    return (
        <div className="flex flex-col gap-6">
            <div className="flex flex-col gap-2">
                <p className="font-semibold">Colours</p>
                <div className="flex gap-3">
                    {device?.colors.map((c) => (
                        <button
                            key={c}
                            onClick={() => onColorChange(c)}
                            className={`w-6 h-6 rounded-full border-2 ${
                                color === c ? "border-green-500" : "border-gray-400"
                            }`}
                            title={c}
                            style={{backgroundColor: getDeviceColorInfo(c).cssName}}
                        />
                    ))}
                </div>
            </div>

            <div className="flex gap-3">
                {device?.storage_gb.map((s) => (
                    <button
                        key={s}
                        onClick={() => onStorageChange(s.toString())}
                        className={`px-4 py-2 rounded-full ${
                            storage === s.toString() ? "bg-gray-900 text-white" : "bg-gray-200"
                        }`}
                    >
                        {`${s}GB`}
                    </button>
                ))}
            </div>
        </div>
    );
}

